import React from 'react';
import moment from 'moment';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {PaperProps, withStyles} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import DatePicker from './DatePicker';

import {DatePickerProps} from './types';

const MONTH_YEAR_LINE = 'MMMM YYYY';

const StyledHeader = withStyles<string, undefined, PaperProps>(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '63px',
        // @ts-ignore
        backgroundColor: theme.palette.background.overlays,

        '&> span': {
            ...theme.typography.button,
            lineHeight: 1.25,
            fontSize: '12px'
        },
        '& button': {
            backgroundColor: 'transparent !important',
            width: 35
        },

        // Close calendar icone
        '& svg': {
            fontSize: '2rem'
        }
    }
}))(Paper);

export interface YearMonthPickerProps extends DatePickerProps {
    onCalendarSwitch?: () => void;
}

const YearMonthPicker = ({value, onChange, onCalendarSwitch, ...props}: YearMonthPickerProps) => (
    <Box>
        <StyledHeader>
            <Typography align="center" component="span" variant="subtitle1">
                {moment(value).format(MONTH_YEAR_LINE)}
            </Typography>
            <IconButton aria-label="close year month calendar" onClick={onCalendarSwitch}>
                <ArrowDropUp />
            </IconButton>
        </StyledHeader>
        <Divider />

        <Box display="flex">
            <Box width="50%">
                <DatePicker
                    autoOk
                    disableFuture
                    disableToolbar
                    variant="static"
                    openTo="month"
                    value={value}
                    onChange={onChange}
                    views={['month']}
                    {...props}
                />
            </Box>
            <Divider flexItem orientation="vertical" />
            <Box width="50%">
                <DatePicker
                    autoOk
                    disableFuture
                    disableToolbar
                    variant="static"
                    openTo="year"
                    value={value}
                    onChange={onChange}
                    views={['year']}
                    {...props}
                />
            </Box>
        </Box>
    </Box>
);

export default YearMonthPicker;
